import React, { useState } from 'react';
import Select from "react-select";

import styles from './PopupAgeConfirm.module.scss';
import Background from "../../assets/images/login_main_container_v2.png";

import { MIN_YEARS_TO_PURCHASE } from "../../shared/constants";

// Generate age options from 18 to 100
const ageOptions = [];
for (let i = 18; i <= 100; i++) {
	ageOptions.push({ value: i, label: i });
}

// Custom styles for react-select
const selectStyles = {
	control: (base) => ({
		...base,
		backgroundColor: '#fff',
		border: 'none',
		minHeight: '45px',
		boxShadow: 'none',
	}),
	singleValue: (base) => ({
		...base,
		color: '#333',
		fontSize: '1.6rem',
	}),
	placeholder: (base) => ({
		...base,
		color: '#999',
	}),
	menu: (base) => ({
		...base,
		zIndex: 9999,
	}),
	menuList: (base) => ({
		...base,
		maxHeight: '180px',
	}),
	option: (base, state) => ({
		...base,
		backgroundColor: state.isSelected ? '#b8373b' : state.isFocused ? '#f0f0f0' : '#fff',
		color: state.isSelected ? '#fff' : '#333',
		fontSize: '1.4rem',
		padding: '10px 12px',
		cursor: 'pointer',
	}),
};

const PopupAgeConfirm = ({ config, onConfirm, onCancel }) => {
	const [age, setAge] = useState(null);

	const handleAgeChange = (val) => {
		setAge(val.value);
	};

	const handleConfirm = () => {
		if (age && age >= MIN_YEARS_TO_PURCHASE) {
			onConfirm();
		}
	};

	const isConfirmDisabled = !age || age < MIN_YEARS_TO_PURCHASE;

	return (
		<div className={styles.overlay}>
			<div className={styles.wrapper}>
				<img src={Background} className={styles.background} alt={''} />
				<div className={styles.content}>
					<div className={styles.header}>
						<div className={styles.title}>{config.ageConfirm.title}</div>
					</div>
					<div className={styles.ageConfirmBody}>
						<div className={styles.title}>{config.ageConfirm.subTitle}</div>
						<div className={styles.message}>
							<p>{config.ageConfirm.message1}</p>
							<p>{config.ageConfirm.message2}</p>
							<p>{config.ageConfirm.message3}</p>
						</div>
					</div>
					<div className={styles.footer}>
						<div className={styles.selectLabel}>{config.ageConfirm.selectLabel}</div>
						<div className={styles.selectWrapper}>
							<Select
								className={styles.ageSelect}
								options={ageOptions}
								defaultValue={null}
								onChange={handleAgeChange}
								placeholder={config.birthdayPlaceholder}
								isSearchable={false}
								menuPlacement="auto"
								maxMenuHeight={180}
								styles={selectStyles}
							/>
						</div>
						<div className={styles.buttons}>
							<div
								className={styles.cancelButton}
								onClick={onCancel}
							>
								{config.ageConfirm.cancelButton}
							</div>
							<div
								className={`${styles.confirmButton} ${isConfirmDisabled ? styles.disabled : ''}`}
								onClick={!isConfirmDisabled ? handleConfirm : undefined}
							>
								{config.ageConfirm.confirmButton}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default PopupAgeConfirm;